<template>
  <div v-loading="loading" class="custom-card">
    <div class="flex justify-between">
      <div class="group-options-select">
        <div class="flex">
          <div class="mr-2  p-2 px-3 filter cursor-pointer hover:shadow-sm " :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList">
            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
          </div>

          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
      </div>

      <primary-button v-if="$_isAdmin" class="d-none d-md-flex" buttonText="New Terminal"
        @click="isNewLocationModal = true" />
      <primary-button class="d-md-none" buttonText="Add" @click="isNewLocationModal = true" />
    </div>
    <!-- large screen -->
    <div class="responsive-table d-none d-md-block">
      <table class="custom-table responsive-table border-collapse">
        <thead>
          <tr class="shadow-table rounded-md">
            <th v-for="opt in options" :key="'hopts' + opt.id">{{ opt.name }}</th>
            <th tabindex="-1">
              <span @click="istableOptionsModal = true" class="cursor-pointer">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg>
              </span>
            </th>
          </tr>
        </thead>
        <tbody v-if="!loading && !filteredLocations.length">
          <tr class="shadow-table rounded-md">
            <td colspan="4">
              <div class="flex flex-col justify-center items-center gap-4">
                <empty-location-icon />
                <p>No Terminal to display.</p>
                <div class="flex gap-2 text-primary-yellow text-center text-sm font-bold cusror-pointer"
                  @click="isNewLocationModal = true">
                  <span>
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="#FCC210" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                        fill="#FCC210" />
                    </svg>
                  </span>
                  Start Adding Terminals
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="locations">
          <tr v-for="location in paginatedList" :key="location.id" class="shadow-table add_table rounded-md">
            <td v-if="isActive('TerminalName')">{{ location.locationName }}</td>
            <td v-if="isActive('TerminalCode')">{{ location.locationCode }}</td>
            <td v-if="isActive('Address')">{{ location.address }}</td>
            <td v-if="isActive('City')">{{ location.city }}</td>
            <td v-if="isActive('Country')">{{ location.country || '' }}</td>
            <td v-if="isActive('ZipCode')">{{ location.zipCode || '' }}</td>
            <td v-if="isActive('DateCreated')"> {{ formatAddress(location.createdAt) }}</td>
            <td v-if="isActive('TerminalManager')">{{ location?.locationManagerDetails?.fullName || '' }} <br >{{ location?.locationManagerDetails?.email || '' }}</td>
            
            <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer">
              <span @click="showActionOptions(location.id)">
                <vertical-ellipsis />
              </span>
              <div class="actions" v-if="selectedRowId == location.id">
                <div>
                  <p>Actions</p>
                  <hr />
                </div>
                <div class="cursor-pointer hover:bg-gray-100" @click="editLocation(location)" v-if="$_isAdmin">
                  <span class="icon">
                    <edit-icon />
                  </span>
                  <span>Edit</span>
                </div>
                <div class="cursor-pointer hover:bg-gray-100" @click="viewLocation(location.id)">
                  <span class="icon">
                    <img src="@/assets/images/location/pin.svg" /></span>
                  <span>View</span>
                </div>
                <div v-if="$_isAdmin" class="cursor-pointer hover:bg-gray-100" @click="
                  (isDeleteModal = true), (singleLocationId = location.id)
                  ">
                  <span class="icon"><img src="@/assets/images/icons/delete-icon.svg" /></span>
                  <span>Delete</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- mobile screen -->
    <div class="d-md-none">

      <div v-for="(location, i) in paginatedList" :key="i" class="custom-card flex justify-between my-3 text-xs">
        <div class="col-11">
          <div class="flex row flex-row justify-between grow">
            <div class="my-3 col-7">
              <div class="flex">
                <div><img src="@/assets/images/icons/location.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2">Terminal Name <br />
                  <span class="font-semibold">{{ location.locationName }}</span>
                </span>
              </div>
            </div>
            <div class="my-3 col col-span-2">
              <div class="flex">
                <div><img src="@/assets/images/icons/location.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2">City <br />
                  <span class="font-semibold">{{ location.city }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex row flex-row justify-between grow">
            <div class="my-3 col-7">
              <div class="flex">
                <div>
                  <img src="@/assets/images/icons/location.svg" class="align-top" alt="" />
                </div>
                <span class="my-auto text-muted ml-2">Address <br />
                  <span class="font-semibold">{{ location.address }}</span>
                </span>
              </div>
            </div>

          </div>

        </div>
        <div class="flex-none">
          <span @click="showActionOptions(location.id)">
            <vertical-ellipsis />
          </span>
          <div class="actions" v-if="selectedRowId == location.id">
            <div>
              <p>Actions</p>
              <hr />
            </div>
            <div class="cursor-pointer hover:bg-gray-100" @click="editLocation(location)">
              <span class="icon">
                <edit-icon />
              </span>
              <span>Edit</span>
            </div>
            <div class="cursor-pointer hover:bg-gray-100" @click="markDefault(location)">
              <span class="icon">
                <edit-icon />
              </span>
              <span>Make Default</span>
            </div>
            <div class="cursor-pointer hover:bg-gray-100" @click="viewLocation(location.id)">
              <span class="icon">
                <img src="@/assets/images/location/pin.svg" /></span>
              <span>View</span>
            </div>
            <div class="cursor-pointer hover:bg-gray-100" @click="
              (isDeleteModal = true), (singleLocationId = location.id)
              ">
              <span class="icon"><img src="@/assets/images/icons/delete-icon.svg" /></span>
              <span>Delete</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination :total="totalLocation" :pageNumber="pageNumber" @pageNumber="setNumDisplayLocation"
      @pageSize="pageSize" />
    <view-location-modal v-if="isLocationModal" :showModal="isLocationModal" @close-modal="isLocationModal = false"
      :locationId="singleLocationId" />
    <new-location-modal v-if="isNewLocationModal" :showModal="isNewLocationModal"
      @close-modal="isNewLocationModal = false" @added-location="getAllLocations" />
    <edit-location-modal v-if="isEditLocationModal" @location-updated="getAllLocations" :showModal="isEditLocationModal"
      :location="editableLocation" @close-modal="isEditLocationModal = false" />
    <delete-modal :showModal="isDeleteModal" :itemToDelete="itemToDelete" :deletingItem="deletingItem"
      @close-modal="isDeleteModal = false" @delete-item="deleteLocation" />

    <TableOptions :showModal="istableOptionsModal" @close-modal="istableOptionsModal = false"
      :setOptions="setOptions" />
  </div>
</template>

<script>
import pagination from "../../../../UI/pagination.vue";
import ViewLocationModal from "./ViewLocationModal";
import NewLocationModal from "./Modals/NewLocationModal";
import EditLocationModal from "./Modals/EditLocationModal";
import DeleteModal from "@/components/UI/Modal/DeleteModal";
import TableOptions from "./Modals/TableOptions.vue";
import moment from "moment";

export default {
  components: {
    pagination,
    ViewLocationModal,
    NewLocationModal,
    EditLocationModal,
    DeleteModal,
    TableOptions
  },
  data() {
    return {
      istableOptionsModal: false,
      selectedRowId: null,
      isLocationModal: false,
      isNewLocationModal: false,
      isEditLocationModal: false,
      locations: [],
      editableLocation: {},
      loading: true,
      singleLocationId: "",
      isDeleteModal: false,
      itemToDelete: "Location",
      deletingItem: false,
      queryString: "",
      sortList: false,
      totalLocation: 1,
      locationPerPage: 10,
      pageNumber: 1,
      options: []
    };
  },
  computed: {
    filteredLocations() {
      return this.filterArray(this.locations, this.queryString);
    },
    lists() {
      return this.sortList
        ? this.filteredLocations
          .map((l) => l)
          .sort((a, b) => {
            var x = a.locationName.toLowerCase();
            var y = b.locationName.toLowerCase();
            return x < y ? -1 : x > y ? 1 : 0;
          })
        : this.filteredLocations;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.locationPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.locationPerPage);
    },
    paginatedList() {
      return this.lists.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return { pageSize: this.locationPerPage, pageNum: this.pageNumber };
    },
  },
  mounted() {
    this.getAllLocations(this.setparams);
  },
  watch: {
    setparams() {
      this.loading = true
      this.getAllLocations(this.setparams);
    }
  },
  methods: {
    formatAddress(val) {
      return moment(val).format('YYYY-MM-DD, hh:mm')
    },
    isActive(itemID) {
      let findIndex = this.options.findIndex((item) => item.id == itemID)
      return findIndex > -1
    },
    setOptions(options) {
      this.options = options
    },
    pageSize(val) {
      this.locationPerPage = val
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    async getAllLocations(params) {
      this.loading = true;
      this.locations = [];
      try {
        let response = await this.$_getAll3plLocations(params);
        console.log("location", params);
        this.locations = response.data.data.locations;
        this.totalLocation = response.data.data.totalCount;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    async deleteLocation() {
      this.deletingItem = true;
      try {
        let response = await this.$_delete3plLocation(this.singleLocationId);
        console.log(response);
        this.onDeleteLocation();
        this.deletingItem = false;
      } catch (error) {
        this.handleError(error);
        this.deletingItem = false;
      }
    },
    onDeleteLocation() {
      this.generateToast("Location successfully deleted!", "success");
      this.getAllLocations();
      this.isDeleteModal = false;
    },
    viewLocation(locationId) {
      this.singleLocationId = locationId;
      this.isLocationModal = true;
    },
    editLocation(location) {
      this.editableLocation = location;
      this.isEditLocationModal = true;
    },
    markDefault() {

    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.add_table {
  td {}
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: flex-end;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  margin: 2rem 0;
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 12rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  .icon {
    width: 2.5em;
  }

  span {
    padding-right: 0.25rem;
  }

  >div {
    padding: 0.75rem;
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
